module.exports = __webpack_public_path__ + "img/建筑_building-two.d5b40025.svg";